import type { IconNode } from '../types';

/**
 * @name toothbrush
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMTFjLTIgMi00IDItNiA0bC03IDciIC8+CiAgPHBhdGggZD0ibTIyIDQtNy40MTQgNy40MTQtMi0yQTIgMiAwIDAxMTQgNmMwLS41MTIuMTk2LTEuMDI0LjU4Ni0xLjQxNEEyIDIgMCAwMTE2IDRhMiAyIDAgMDEzLjI2Mi0xLjU1MmwyLjE1MiAyLjEzOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/toothbrush
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Toothbrush: IconNode = [
  ['path', { d: 'M15 11c-2 2-4 2-6 4l-7 7' }],
  [
    'path',
    {
      d: 'm22 4-7.414 7.414-2-2A2 2 0 0114 6c0-.512.196-1.024.586-1.414A2 2 0 0116 4a2 2 0 013.262-1.552l2.152 2.138',
    },
  ],
];

export default Toothbrush;
